import { useEffect, useState } from "react";

import { fetchCities } from "./metadata";

type UseCitiesOptions = {
  limit?: number;
  page?: number;
};

export function useCities(options?: UseCitiesOptions) {
  const [data, setData] = useState<string[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const limit = options?.limit ?? 200;
  const page = options?.page ?? 1;

  useEffect(() => {
    let isMounted = true;

    fetchCities(limit, page)
      .then((cities) => {
        if (!isMounted) return;
        setData(cities);
        setError(null);
      })
      .catch(() => {
        if (!isMounted) return;
        setError("Impossible de charger les villes.");
      })
      .finally(() => {
        if (!isMounted) return;
        setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [limit, page]);

  return { data, loading, error };
}
